import React, { useContext, useEffect, useState } from "react"
import sagyouin from "../../source/img/clipboard_sagyouin_man.png"
import { useSelector } from "react-redux"
import { RootState } from "../../globalStore/rootreducer"
import { CSS_PROPERTY } from "../../features/Tablet/cssProperties/tablet"
import { 区分分類コード } from "../../constant/enum/codes"
import { 区分マスタ } from "../../service/master/kubun/TKubun"
import KubunService from "../../service/master/kubun/kubunService"
import { TenkoHeaderContext } from "../../features/Tablet/context/context"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TTenkoIcon名称, tenkoIcon } from "../../constant/icons"
import { useLocation } from "react-router-dom"
import { tenkoListPage } from "../../constant/tablet/pages"
import dayjs from "dayjs"

const TenkosyaInfo: React.FC<{ children?: React.ReactNode }> = React.memo(
  ({ children }) => {
    const location = useLocation()
    const { LoginUserInfo: userInfo } = useSelector(
      (state: RootState) => state.user
    )
    const { 点呼ヘッダ情報 } = useContext(TenkoHeaderContext)
    const [天候区分List, set天候区分List] = useState<区分マスタ[]>([])
    const [天候区分, set天候区分] = useState<区分マスタ>()

    useEffect(() => {
      Promise.all([
        new KubunService().getList({
          分類コード: 区分分類コード.運行管理_勤怠.天候区分,
        }),
      ]).then(async ([天候区分Res]) => {
        天候区分Res &&
          天候区分Res.data &&
          set天候区分List([...天候区分Res.data])
      })
    }, [])

    useEffect(() => {
      if (点呼ヘッダ情報 == null || 天候区分List == null) return

      set天候区分(
        天候区分List.find((d) => d.区分コード === 点呼ヘッダ情報.天候区分コード)
      )
    }, [点呼ヘッダ情報, 天候区分List])

    return (
      <table
        className="w-100"
        style={{
          height: "6rem",
          visibility: userInfo.社員ID ? "visible" : "hidden",
          padding: "0 !important",
          tableLayout: "fixed",
        }}>
        <tbody>
          <tr
            style={{
              padding: "0 !important",
            }}>
            <td
              style={{
                padding: "0 !important",
              }}>
              {children ? (
                <>{children}</>
              ) : (
                点呼ヘッダ情報 && (
                  <>
                    点呼日:
                    {dayjs(点呼ヘッダ情報.点呼日).format("MM/DD (ddd)")}
                  </>
                )
              )}
            </td>
            {/* 点呼一覧以外は表示する */}
            {location.pathname !== tenkoListPage.Route.path &&
              天候区分 != null && (
                <td
                  className="text-center"
                  style={{
                    padding: "0 !important",
                    width: "8%",
                    verticalAlign: "top",
                  }}>
                  <div
                    className="text-center"
                    style={{
                      height: "8rem",
                      width: "8rem",
                      margin: "1.2rem 0",
                      ...CSS_PROPERTY.BORER_PROPERTIES,
                      backgroundColor: "white",
                    }}>
                    <div style={{ fontSize: "2.5rem" }}>
                      <FontAwesomeIcon
                        icon={tenkoIcon[`${天候区分.名称2}` as TTenkoIcon名称]}
                        style={{
                          color: CSS_PROPERTY.WEATHER_COLOR[天候区分.名称2],
                        }}
                      />
                      <div>
                        <span style={{ fontSize: "2rem" }}>
                          {天候区分.名称1}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              )}
            <td
              className="text-end"
              style={{
                padding: "0 !important",
                width: "40%",
              }}>
              <table className="me-4 d-inline-block" style={{ height: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <div
                        className="text-center"
                        style={{
                          height: "8rem",
                          width: "8rem",
                          margin: "1rem",
                          padding: "1rem 1rem 1rem 1rem",
                          ...CSS_PROPERTY.BORER_PROPERTIES,
                          backgroundColor: "white",
                        }}>
                        <img
                          src={sagyouin}
                          style={{
                            height: "6rem",
                            width: "auto",
                          }}
                          alt=""></img>
                      </div>
                    </td>
                    <td
                      className="text-start w-25rem"
                      style={{ fontSize: "2.5rem" }}>
                      <table>
                        <tbody>
                          <tr>
                            <td className="text-end">{userInfo.部所コード}</td>
                            <td>:</td>
                            <td className="text-start">{userInfo.部所略称}</td>
                          </tr>
                          <tr>
                            <td className="text-end">{userInfo.社員コード}</td>
                            <td>:</td>
                            <td className="text-start">{userInfo.社員氏名}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
)

export default TenkosyaInfo
